import { motion } from "framer-motion"
import { ReactNode } from "react"

const stepVariants = {
  enter: {
    x: 20,
    opacity: 0
  },
  center: {
    x: 0,
    opacity: 1
  },
  exit: {
    x: -20,
    opacity: 0
  }
}

interface SleepStepContainerProps {
  children: ReactNode
}

export function SleepStepContainer({ children }: SleepStepContainerProps) {
  return (
    <motion.div
      variants={stepVariants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={{
        x: { type: "spring", stiffness: 300, damping: 30 },
        opacity: { duration: 0.2 }
      }}
    >
      {children}
    </motion.div>
  )
}